import { Box, Divider, Link, Stack, Typography } from "@mui/material";
import { globalMaxWidth } from "../GlobalConfigs";
import logo_ull_white from "../images/logo_ull_white.svg";
import logo_ursi_blanco from "../images/ursi-logo-blanco_2.png";
import React from "react";
import TelegramIcon from '@mui/icons-material/Telegram';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

export function BottomBanner() {
    return (<Stack alignItems='center' sx={{
        backgroundColor: 'black', width: 1
    }}>
        <Stack sx={{
            width: 1,
            maxWidth: globalMaxWidth
        }}>
            <Stack spacing={{ lg: 4, md: 2 }} sx={{
                m: { lg: 4, xs: 1 }
            }}>
                <Stack direction='row' padding={0} justifyContent={{ xs: 'center', md: 'space-between' }} alignItems='center' sx={{
                    pt: 3,
                    pb: 2,
                    flexWrap: 'wrap',
                    rowGap: { xs: 1, md: 0 },
                    columnGap: { xs: 4, md: 0 }
                }}>
                    <Link href="https://www.ull.es" target="_blank" rel="noopener">
                        <Box component='img' sx={{ height: { lg: "94px", xs: "41px" }, p: { lg: 3, xs: 1 } }}
                            src={logo_ull_white}
                            alt={"Logo ULL"}
                            loading="lazy" />
                    </Link>

                    <Divider sx={{ display: { xs: 'block', md: 'none' }, width: '100%', bgcolor: 'rgba(255,255,255,0.5)', my: 1, order: { xs: -1, md: 0 } }} />

                    <Stack direction='row' spacing={{ xs: 0, md: 3 }} justifyContent={{ xs: 'space-around', md: 'center' }} alignItems='center'
                        sx={{
                            flex: { md: 1, xs: '0 0 100%' },
                            order: { xs: -2, md: 0 },
                            mb: { xs: 1, md: 0 },
                            px: 2
                        }}>
                        <Link href="https://t.me/ursi_es" target="_blank" rel="noopener" color='inherit' underline='none'
                            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', transition: '0.3s', '&:hover': { opacity: 0.7, transform: 'scale(1.05)' } }}>
                            <TelegramIcon sx={{ fontSize: { lg: "40px", xs: "24px" }, mb: 0.5, color: 'white' }} />
                            <Typography variant='caption' sx={{ fontWeight: 'bold', color: 'white', letterSpacing: 1, fontSize: { xs: '8px', md: '10px' } }}>TELEGRAM</Typography>
                            <Typography variant='caption' sx={{ opacity: 0.6, fontSize: '8px', color: 'white', textAlign: 'center', display: { xs: 'none', sm: 'block' } }}>Canal oficial</Typography>
                        </Link>

                        <Link href="https://forms.gle/n9nyiyUZpc412Z9m9" target="_blank" rel="noopener" color='inherit' underline='none'
                            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', transition: '0.3s', '&:hover': { opacity: 0.7, transform: 'scale(1.05)' } }}>
                            <PersonAddIcon sx={{ fontSize: { lg: "40px", xs: "24px" }, mb: 0.5, color: 'white' }} />
                            <Typography variant='caption' sx={{ fontWeight: 'bold', color: 'white', letterSpacing: 1, fontSize: { xs: '8px', md: '10px' } }}>ASOCIARSE</Typography>
                            <Typography variant='caption' sx={{ opacity: 0.6, fontSize: '8px', color: 'white', textAlign: 'center', display: { xs: 'none', sm: 'block' } }}>Hazte socio</Typography>
                        </Link>

                        <Link href="https://listserv.rediris.es/cgi-bin/wa?SUBED1=URSISPAIN&A=1" target="_blank" rel="noopener" color='inherit' underline='none'
                            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', transition: '0.3s', '&:hover': { opacity: 0.7, transform: 'scale(1.05)' } }}>
                            <MailOutlineIcon sx={{ fontSize: { lg: "40px", xs: "24px" }, mb: 0.5, color: 'white' }} />
                            <Typography variant='caption' sx={{ fontWeight: 'bold', color: 'white', letterSpacing: 1, fontSize: { xs: '8px', md: '10px' } }}>LISTA</Typography>
                            <Typography variant='caption' sx={{ opacity: 0.6, fontSize: '8px', color: 'white', textAlign: 'center', display: { xs: 'none', sm: 'block' } }}>Distribución</Typography>
                        </Link>
                    </Stack>

                    <Link href="https://www.ursi.es" target="_blank" rel="noopener">
                        <Box component='img' sx={{ height: { lg: "94px", xs: "41px" } }}
                            src={logo_ursi_blanco}
                            alt={"Logo URSI"}
                            loading="lazy" />
                    </Link>

                </Stack>
                <Stack direction='row' alignItems='center' justifyContent='space-around'>
                    {/*<Typography variant='body1' color='white' sx={{width:'45px'}}>*/}
                    {/*    Desarrollado por: Óscar Gómez Cárdenes*/}
                    {/*</Typography>*/}
                    <Typography variant='body2' color='white'
                        sx={{ fontSize: { lg: "18px", md: "18px", sm: "11px", xs: "9px" } }}
                    >
                        © 2026 URSI La Laguna | <Link href='/politica-privacidad' color='inherit' underline='hover'>Política de Privacidad</Link> | <Link href='/aviso-legal' color='inherit' underline='hover'>Aviso Legal</Link> | <Link href='/cookies' color='inherit' underline='hover'>Cookies</Link>
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    </Stack>)
}